import styled from '@themes/theme'

export const ChangeProfileWrap = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  .select-photo-input {
    position: absolute;
    bottom: 0;
    width: 0;
    line-height: 999;
    text-indent: 999px;
    overflow: hidden;
    color: transparent;
  }
  .change-profile-btn {
    display: flex;
    align-items: center;
    width: calc(100% - 40px);
    height: 40px;
    margin-bottom: 16px;
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.large};
    background: none;
    &.reset {
      margin-bottom: 28px;
    }
    .ico-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 31px;
      height: 31px;
      margin-right: 10px;
      border-radius: 50%;
      background: ${props => props.theme.color.modalSubBg};
      svg {
        width: 20px;
        path {
          fill: ${props => props.theme.color.modalTxt};
        }
      }
    }
  }
`
